// The auth payload returned by the backend and persisted to sessionStorage.
// Shape is intentionally identical to the legacy app so the backend contract is
// unchanged.
export interface LocalData {
    isSignedin: boolean;
    token: string;
    roles: string[];
}

export const emptyAuth: LocalData = {
    isSignedin: false,
    token: '',
    roles: [],
};
